import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import EntityCosts from "components/EntityCosts";

/**
 * @component
 * @category Scenes
 * @subcategory Brand
 */
class Costs extends React.Component {
    render() {
        return <EntityCosts type="brand" id={this.props.brandId} />;
    }
}

Costs.propTypes = {
    brandId: PropTypes.number.isRequired,
};

export default withRouter(Costs);
